import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project5Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        Started as an exploration of networking fundamentals, this project set out to clone the core
                        mechanics of BitTorrent: downloading a single file by sourcing chunks from multiple peers at
                        once. To make it a real challenge, I built it in C rather than a language with more forgiving
                        networking libraries.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A client implementing peer discovery, chunked downloading, and data sharing over raw sockets.</li>
                        <li>Logic to request and reassemble file chunks sourced from multiple peers concurrently.</li>
                        <li>Manual memory and connection management, since C provides neither garbage collection nor a built-in networking abstraction.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The client successfully reassembled a complete file from peer-sourced chunks, validating the
                        core protocol. It was built purely as a learning exercise in low-level network programming
                        and was not developed further after that milestone.
                    </p>

                    <p className='text-muted mb-0'><i>Completed December 2020</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project5Card;
